export interface GradientTemplate {
  name: string;
  description: string;
  category: string;
  gradient: string;
  direction: string;
  colors: string[];
}

export const gradientTemplates: GradientTemplate[] = [
  // 经典渐变
  {
    name: '经典蓝紫',
    description: '经典的蓝紫色渐变，优雅而专业',
    category: '经典',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    direction: '135deg',
    colors: ['#667eea', '#764ba2']
  },
  {
    name: '温暖橙红',
    description: '温暖的橙红色渐变，充满活力',
    category: '经典',
    gradient: 'linear-gradient(135deg, #ff7e5f 0%, #feb47b 100%)',
    direction: '135deg',
    colors: ['#ff7e5f', '#feb47b']
  },
  {
    name: '清新绿蓝',
    description: '清新的绿色到蓝色渐变，自然舒适',
    category: '经典',
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    direction: '135deg',
    colors: ['#4facfe', '#00f2fe']
  },
  {
    name: '浪漫粉紫',
    description: '浪漫的粉色到紫色渐变，温柔优雅',
    category: '经典',
    gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    direction: '135deg',
    colors: ['#f093fb', '#f5576c']
  },

  // 现代渐变
  {
    name: '霓虹蓝绿',
    description: '现代霓虹蓝绿色渐变，科技感十足',
    category: '现代',
    gradient: 'linear-gradient(135deg, #00d4ff 0%, #00ff88 100%)',
    direction: '135deg',
    colors: ['#00d4ff', '#00ff88']
  },
  {
    name: '金属银灰',
    description: '金属质感的银灰色渐变，高端大气',
    category: '现代',
    gradient: 'linear-gradient(135deg, #bdc3c7 0%, #2c3e50 100%)',
    direction: '135deg',
    colors: ['#bdc3c7', '#2c3e50']
  },
  {
    name: '电光紫蓝',
    description: '电光效果的紫蓝色渐变，未来感强烈',
    category: '现代',
    gradient: 'linear-gradient(135deg, #8b5cf6 0%, #3b82f6 100%)',
    direction: '135deg',
    colors: ['#8b5cf6', '#3b82f6']
  },
  {
    name: '极光绿',
    description: '极光般的绿色渐变，神秘而美丽',
    category: '现代',
    gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    direction: '135deg',
    colors: ['#10b981', '#059669']
  },

  // 彩虹渐变
  {
    name: '彩虹光谱',
    description: '完整的彩虹光谱渐变，色彩丰富',
    category: '彩虹',
    gradient: 'linear-gradient(135deg, #ff6b6b 0%, #4ecdc4 25%, #45b7d1 50%, #96ceb4 75%, #feca57 100%)',
    direction: '135deg',
    colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57']
  },
  {
    name: '彩虹横条',
    description: '横向彩虹渐变，活力四射',
    category: '彩虹',
    gradient: 'linear-gradient(90deg, #ff6b6b 0%, #feca57 16.66%, #48dbfb 33.33%, #0abde3 50%, #006ba6 66.66%, #3742fa 83.33%, #2f3542 100%)',
    direction: '90deg',
    colors: ['#ff6b6b', '#feca57', '#48dbfb', '#0abde3', '#006ba6', '#3742fa', '#2f3542']
  },
  {
    name: '彩虹对角',
    description: '对角彩虹渐变，动感十足',
    category: '彩虹',
    gradient: 'linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4, #feca57, #ff9ff3, #54a0ff)',
    direction: '45deg',
    colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57', '#ff9ff3', '#54a0ff']
  },

  // 自然渐变
  {
    name: '森林绿',
    description: '森林般的绿色渐变，自然清新',
    category: '自然',
    gradient: 'linear-gradient(135deg, #56ab2f 0%, #a8e6cf 100%)',
    direction: '135deg',
    colors: ['#56ab2f', '#a8e6cf']
  },
  {
    name: '海洋蓝',
    description: '海洋般的蓝色渐变，深邃宁静',
    category: '自然',
    gradient: 'linear-gradient(135deg, #2196f3 0%, #21cbf3 100%)',
    direction: '135deg',
    colors: ['#2196f3', '#21cbf3']
  },
  {
    name: '日落橙',
    description: '日落般的橙红色渐变，温暖浪漫',
    category: '自然',
    gradient: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 50%, #fecfef 100%)',
    direction: '135deg',
    colors: ['#ff9a9e', '#fecfef']
  },
  {
    name: '天空蓝',
    description: '天空般的蓝色渐变，清澈透明',
    category: '自然',
    gradient: 'linear-gradient(135deg, #74b9ff 0%, #0984e3 100%)',
    direction: '135deg',
    colors: ['#74b9ff', '#0984e3']
  },

  // 深色渐变
  {
    name: '深空紫',
    description: '深空般的紫色渐变，神秘深邃',
    category: '深色',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    direction: '135deg',
    colors: ['#667eea', '#764ba2']
  },
  {
    name: '午夜蓝',
    description: '午夜般的深蓝色渐变，沉稳优雅',
    category: '深色',
    gradient: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
    direction: '135deg',
    colors: ['#2c3e50', '#34495e']
  },
  {
    name: '炭黑灰',
    description: '炭黑到灰色的渐变，极简现代',
    category: '深色',
    gradient: 'linear-gradient(135deg, #2c3e50 0%, #bdc3c7 100%)',
    direction: '135deg',
    colors: ['#2c3e50', '#bdc3c7']
  },

  // 特殊效果
  {
    name: '金属光泽',
    description: '金属光泽效果渐变，高端质感',
    category: '特殊',
    gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 50%, #4facfe 100%)',
    direction: '135deg',
    colors: ['#f093fb', '#f5576c', '#4facfe']
  },
  {
    name: '霓虹发光',
    description: '霓虹发光效果渐变，炫酷时尚',
    category: '特殊',
    gradient: 'linear-gradient(135deg, #00d4ff 0%, #00ff88 50%, #ff6b6b 100%)',
    direction: '135deg',
    colors: ['#00d4ff', '#00ff88', '#ff6b6b']
  },
  {
    name: '水波纹',
    description: '水波纹效果渐变，流动感强',
    category: '特殊',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #f5576c 75%, #4facfe 100%)',
    direction: '135deg',
    colors: ['#667eea', '#764ba2', '#f093fb', '#f5576c', '#4facfe']
  },
  {
    name: '极光效果',
    description: '极光效果渐变，梦幻神秘',
    category: '特殊',
    gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 50%, #d299c2 100%)',
    direction: '135deg',
    colors: ['#a8edea', '#fed6e3', '#d299c2']
  },

  // 径向渐变
  {
    name: '径向蓝紫',
    description: '径向蓝紫色渐变，中心向外扩散',
    category: '径向',
    gradient: 'radial-gradient(circle, #667eea 0%, #764ba2 100%)',
    direction: 'circle',
    colors: ['#667eea', '#764ba2']
  },
  {
    name: '径向彩虹',
    description: '径向彩虹渐变，中心向外扩散',
    category: '径向',
    gradient: 'radial-gradient(circle, #ff6b6b 0%, #4ecdc4 25%, #45b7d1 50%, #96ceb4 75%, #feca57 100%)',
    direction: 'circle',
    colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57']
  },
  {
    name: '径向日落',
    description: '径向日落渐变，温暖中心',
    category: '径向',
    gradient: 'radial-gradient(circle, #ff7e5f 0%, #feb47b 100%)',
    direction: 'circle',
    colors: ['#ff7e5f', '#feb47b']
  },

  // 对角渐变
  {
    name: '对角蓝绿',
    description: '对角蓝绿色渐变，动感十足',
    category: '对角',
    gradient: 'linear-gradient(45deg, #4facfe 0%, #00f2fe 100%)',
    direction: '45deg',
    colors: ['#4facfe', '#00f2fe']
  },
  {
    name: '对角粉橙',
    description: '对角粉橙色渐变，活力四射',
    category: '对角',
    gradient: 'linear-gradient(45deg, #ff9a9e 0%, #fecfef 100%)',
    direction: '45deg',
    colors: ['#ff9a9e', '#fecfef']
  },
  {
    name: '对角紫红',
    description: '对角紫红色渐变，神秘优雅',
    category: '对角',
    gradient: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)',
    direction: '45deg',
    colors: ['#667eea', '#764ba2']
  }
];

export const getGradientsByCategory = (category: string) => {
  return gradientTemplates.filter(template => template.category === category);
};

export const getAllGradientCategories = () => {
  const categories = gradientTemplates.map(template => template.category);
  return Array.from(new Set(categories));
};





